import React from 'react'
import useModal from './modalHook';
import CreateExpense from '../views/shared/settings/expenses/CreateExpense';
import { useQueryClient } from '@tanstack/react-query';

const useExpenses = () => {
    const { ModalComponent, updateModalStates, closeModal } = useModal();
    const queryClient = useQueryClient();
    const ExpenseModal = ModalComponent;

     const addExpense = () => {
            updateModalStates({
                show: true,
                size: 'xl',
                children: (
                    <CreateExpense
                        onProceed={() => {
                            closeModal();
                            queryClient.invalidateQueries({ queryKey: ['getExpenses'] });
                        }}
                        onClose={closeModal}
                    />
                ),
                
                classes: '!p-0 r-[5px]'
            });
        };
    
  return {
    addExpense,
    ExpenseModal
  }
}

export default useExpenses